import { render, staticRenderFns } from "./ConnectRewardsForm.vue?vue&type=template&id=236f0c7e"
import script from "./ConnectRewardsForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConnectRewardsForm.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ConnectRewardsForm.vue?vue&type=style&index=0&id=236f0c7e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports